'use strict';

intellidealerAppCoreModule.factory('workOrdersResource', function ($resource, appConfigurationService) {
  
  var resource = $resource(appConfigurationService.basePath + '/rest/workorders/');
  resource.assignedWorkOrdersByStockNumber =  $resource(appConfigurationService.basePath + '/rest/workorders/assignedWorkOrdersByStockNumber');
  
  return resource;
});
